(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/app.js');
'use strict';

const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const PlayerRegistrationReduxProvider = svs.playerRegistration.store.PlayerRegistrationReduxProvider;
const routes = svs.playerRegistration.constants.routes;
const baseUrl = svs.core.data.baseUrl;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const ScrollTopOnNav = svs.tb_ui_react.scrollTop.ScrollTopOnNav;
const SetDepositLimits = svs.playerRegistration.pages.depositLimits.SetDepositLimits;
const Register = svs.playerRegistration.pages.register.Register;
const AccountCreated = svs.playerRegistration.pages.accountCreated.AccountCreated;
const Kyc = svs.playerRegistration.pages.kyc.Kyc;
const Deposit = svs.playerRegistration.pages.deposit.Deposit;
const Rejected = svs.playerRegistration.pages.rejected.Rejected;
const _svs$playerRegistrati = svs.playerRegistration.components,
  HeaderLogo = _svs$playerRegistrati.HeaderLogo,
  AnimatedColumns = _svs$playerRegistrati.AnimatedColumns;
const useStatusBarColor = svs.components.tb_ui_react.useStatusBarColor.useStatusBarColor;
const PlayerRegistrationApp = () => {
  useStatusBarColor('player-registration-header');
  return React.createElement(PlayerRouter, {
    basename: baseUrl,
    className: "bg-white",
    withRouter: true
  }, React.createElement(ErrorBoundary, null, React.createElement(PlayerRegistrationReduxProvider, null, React.createElement(HeaderLogo, null), React.createElement(ScrollTopOnNav, null, React.createElement("div", null, React.createElement(Route, {
    exact: true,
    path: routes.HOME,
    render: () => React.createElement(Register, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.ACCOUNT_CREATED,
    render: () => React.createElement(AccountCreated, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.DEPOSIT_LIMITS,
    render: () => React.createElement(SetDepositLimits, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.KYC,
    render: () => React.createElement(Kyc, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.KYC_RESUME,
    render: () => React.createElement(Kyc, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.DEPOSIT,
    render: () => React.createElement(Deposit, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.REJECTED,
    render: () => React.createElement(Rejected, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.ANIMATION,
    render: () => React.createElement(AnimatedColumns, null)
  }))))));
};
svs.playerRegistration.PlayerRegistrationApp = PlayerRegistrationApp;

 })(window);